(function () {
  var AUTO_HIDE_MS = 5000;

  function handleSubmit(form) {
    var wrap = form.closest('.signup-form-wrap');
    var successEl = wrap ? wrap.querySelector('.signup-form__success') : null;
    var submitBtn = form.querySelector('[type="submit"]');
    var emailInput = form.querySelector('input[type="email"]');

    var textContainer = form.parentElement;
    var defaultTextEl = textContainer ? textContainer.querySelector('[data-signup-default-text]') : null;
    var successTextEl = textContainer ? textContainer.querySelector('[data-signup-success-text]') : null;

    // Capture the real endpoint, then strip the form's own action so it can
    // never fall back to a native (page-refreshing) submit for any reason —
    // the fetch below is the only thing that actually sends the request.
    var actionUrl = form.action;
    form.removeAttribute('action');

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (emailInput && !emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      if (submitBtn) submitBtn.disabled = true;

      fetch(actionUrl, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then(function () {
          if (successEl) {
            form.hidden = true;
            successEl.hidden = false;
            clearTimeout(successEl._hideTimer);
            successEl._hideTimer = setTimeout(function () {
              successEl.hidden = true;
              form.reset();
              form.hidden = false;
              if (submitBtn) submitBtn.disabled = false;
            }, AUTO_HIDE_MS);
          } else {
            form.reset();
            if (submitBtn) submitBtn.disabled = false;

            if (successTextEl) {
              if (defaultTextEl) defaultTextEl.hidden = true;
              successTextEl.hidden = false;
              clearTimeout(successTextEl._hideTimer);
              successTextEl._hideTimer = setTimeout(function () {
                successTextEl.hidden = true;
                if (defaultTextEl) defaultTextEl.hidden = false;
              }, AUTO_HIDE_MS);
            }
          }
        })
        .catch(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  document.querySelectorAll('.signup-form-wrap form, #secret-sundays-form').forEach(function (form) {
    if (form.dataset.ajaxBound) return;
    form.dataset.ajaxBound = 'true';
    handleSubmit(form);
  });
})();
